interface MaintenanceScreenProps {
  siteName: string;
  message: string;
}

export default function MaintenanceScreen({ siteName, message }: MaintenanceScreenProps) {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-background-50 px-4 py-16 text-center">
      <span className="w-16 h-16 rounded-full bg-accent-100 text-accent-700 flex items-center justify-center">
        <i className="ri-tools-line text-3xl" aria-hidden="true"></i>
      </span>
      <h1 className="mt-6 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
        {siteName} şu an bakımda
      </h1>
      <p className="mt-3 max-w-md text-sm md:text-base text-foreground-600 leading-relaxed">
        {message}
      </p>
      <p className="mt-8 text-xs text-foreground-500">
        Kısa bir süre sonra tekrar bekleriz.
      </p>
    </div>
  );
}